/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skills_Team_CountInputs */

const en_tables_skills_team_count = /** @type {(inputs: Tables_Skills_Team_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Count`)
};

const de_tables_skills_team_count = /** @type {(inputs: Tables_Skills_Team_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Anzahl`)
};

/**
* | output |
* | --- |
* | "Team Count" |
*
* @param {Tables_Skills_Team_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skills_team_count = /** @type {((inputs?: Tables_Skills_Team_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skills_Team_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skills_team_count(inputs)
	return de_tables_skills_team_count(inputs)
});